<template>
  <div class="base">
    <div class="top-area">
      <inside-header color="black" title="我的收益" />
      <div class="total-assets">
        <div class="title">
          总资产
        </div>
        <div class="total">
          {{ (parseFloat(teacher_profix_info.total_revenue) - parseFloat(teacher_profix_info.cash_withdrawn)).toFixed(2)
          }}
        </div>
        <div class="withdrawal">
          <a-button type="primary" @click="goWithdrawal">
            提现
          </a-button>
        </div>
      </div>
      <div class="capital-detail">
        <a-row style="text-align: center">
          <a-col :span="8">
            <div class="number">
              <span>{{ teacher_profix_info.total_revenue }}</span>
            </div>
            <div class="label">
              <span>总收益</span>
            </div>
            <div class="orange-block" />
          </a-col>
          <a-col :span="8">
            <div class="number">
              <span>{{ teacher_profix_info.be_settled }}</span>
            </div>
            <div class="label">
              <span>待结算</span>
            </div>
            <div class="green-block" />
          </a-col>
          <a-col :span="8">
            <div class="number">
              <span>{{ teacher_profix_info.cash_withdrawn }}</span>
            </div>
            <div class="label">
              <span>已提现</span>
            </div>
            <div class="blue-block" />
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="main">
      <div class="operation">
        <van-cell title="提现记录" is-link to="withdrawal-record" />
        <van-cell title="收益明细" is-link to="income-details" />
        <van-cell title="提现问题" is-link to="" />
        <van-cell title="资产说明" is-link to="" />
      </div>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  data() {
    return {
      loading: true,
      teacher_profix_info: {}
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      // 加载数据
      this.loading = true
      this.$http({
        url: '/index/teacher/accountIncome',
        method: 'get',
        params: {
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.teacher_profix_info = data.teacher_profix_info
          console.log(data)
        } else {
          this.$toast.fail('系统繁忙，请刷新重试')
        }
      })
    },
    goWithdrawal() {
      this.$router.push({ name: 'TeacherWithdrawal' })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .top-area {
    background-color: #25292c;

    .total-assets {
      background-color: #25292c;
      padding: 10px 0px;

      .title {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 28px;
        color: #e2e2e2;
        text-align: center;
      }

      .total {
        font-family: Bahnschrift-SemiBold;
        font-size: 30px;
        line-height: 28px;
        color: #fefefe;
        text-align: center;
        margin-top: 10px;
      }

      .withdrawal {
        text-align: center;
        margin-top: 25px;

        button {
          width: 75px;
          height: 31px;
          background-color: #ff5c00;
          border-radius: 15px;
        }
      }
    }

    .capital-detail {
      background-color: #25292c;
      padding: 10px 0px;

      .number {
        font-family: PingFang-SC-Medium;
        font-size: 16px;
        line-height: 28px;
        color: #ffffff;
      }

      .label {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 28px;
        color: #e2e2e2;
      }

      .orange-block {
        width: 10px;
        height: 4px;
        background-color: #ff5c00;
        border-radius: 2px;
        margin: auto;
      }

      .green-block {
        width: 10px;
        height: 4px;
        background-color: #5bc979;
        border-radius: 2px;
        margin: auto;
      }

      .blue-block {
        width: 10px;
        height: 4px;
        background-color: #4b70fd;
        border-radius: 2px;
        margin: auto;
      }
    }

  }

  .main {
    padding: 15px;

    .operation {
      margin-top: 20px;
    }
  }
</style>
